import { useState, type ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';

const HEADER_CLS =
  'flex w-full items-center gap-1.5 px-0.5 py-1 text-[11px] font-semibold uppercase ' +
  'tracking-wider text-faint transition-colors hover:text-foreground';

interface CollapsibleProps {
  title: string;
  defaultOpen?: boolean;
  right?: ReactNode;
  children: ReactNode;
}

/**
 * A lightweight section toggle for the production page. Renders a slim clickable
 * header (chevron + title + optional right-hand slot) above its children and
 * collapses them. Kept chrome-free so it sits cleanly above cards that bring
 * their own styling.
 */
export default function Collapsible({ title, defaultOpen = false, right, children }: CollapsibleProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button onClick={() => setOpen((o) => !o)} className={HEADER_CLS}>
        <ChevronRight className={`h-3.5 w-3.5 shrink-0 text-primary transition-transform ${open ? 'rotate-90' : ''}`} />
        <span>{title}</span>
        {right && <span className="ml-auto normal-case">{right}</span>}
      </button>
      {open && <div className="mt-2.5">{children}</div>}
    </div>
  );
}
